import {cloneDeep, merge} from 'lodash';
import {DeepPartial} from 'utility-types';

import {PaletteColorsEnum} from '../../../../../core/src/models/api/paletteModel';
import {colorPrimitive} from '../../../styles/primitives/colorPrimitive';
import {redesignedLightAccentSemanticStyles} from '../../semantic/accentSemanticStyles';
import {redesignedLightAppFrameSemanticStyles} from '../../semantic/appFrameSemanticStyles';
import {redesignedLightBackgroundSemanticStyles} from '../../semantic/backgroundSemanticStyles';
import {redesignedLightBorderSemanticStyles} from '../../semantic/borderSemanticStyles';
import {redesignedLightConversationCellSemanticStyles} from '../../semantic/cellSemanticStyles';
import {redesignedLightCommentComposerSemanticStyles} from '../../semantic/commentComposerSemanticStyles';
import {redesignedLightInlineBannerSemanticStyles} from '../../semantic/inlineBannerSemanticStyles';
import {redesignedLightInputSemanticStyles} from '../../semantic/inputSemanticStyles';
import {redesignedLightLeftBarSemanticStyles} from '../../semantic/leftBarSemanticStyles';
import {redesignedLightMessageSemanticStyles} from '../../semantic/messageSemanticStyles';
import {redesignedLightMetricsSemanticStyles} from '../../semantic/metricsSemanticStyles';
import {redesignedLightSearchBarSemanticStyles} from '../../semantic/searchBarSemanticStyles';
import {redesignedLightSidePanelSemanticStyles} from '../../semantic/sidePanelSemanticStyles';
import {redesignedLightToggleSemanticStyles} from '../../semantic/toggleSemanticStyles';
import {redesignedLightTopBarSemanticStyles} from '../../semantic/topBarSemanticStyles';
import {redesignedLightVerticalSwitcherSemanticStyles} from '../../semantic/verticalSwitcherSemanticStyles';
import {UserTheme} from '../../themeTypes';
import {lightTheme} from '../lightTheme';

export const redesignedLightTheme: UserTheme = merge(cloneDeep(lightTheme), {
  hasInboxRedesign: true,
  rounded: false,

  cell: redesignedLightConversationCellSemanticStyles,
  leftBar: redesignedLightLeftBarSemanticStyles,

  appFrame: redesignedLightAppFrameSemanticStyles,

  background: redesignedLightBackgroundSemanticStyles,
  foreground: redesignedLightBackgroundSemanticStyles.surface.highlight,

  accent: redesignedLightAccentSemanticStyles,

  typography: {
    shades: {
      interactive: colorPrimitive.blurple[700],
      'interactive-hover': colorPrimitive.blurple[800],

      link: colorPrimitive.blurple[700],
      'link-hover': colorPrimitive.blurple[800],
    },
  },

  input: redesignedLightInputSemanticStyles,
  toggle: redesignedLightToggleSemanticStyles,
  metrics: redesignedLightMetricsSemanticStyles,
  border: redesignedLightBorderSemanticStyles,
  palette: {
    [PaletteColorsEnum.BLUE]: {
      shade10: colorPrimitive.blurple[100],
      shade20: colorPrimitive.blurple[200],
      shade30: colorPrimitive.blurple[300],
      shade40: colorPrimitive.blurple[600],
      shade50: colorPrimitive.blurple[700],
    },
  },
  inlineBanner: redesignedLightInlineBannerSemanticStyles,

  commentComposer: redesignedLightCommentComposerSemanticStyles,
  topBar: redesignedLightTopBarSemanticStyles,
  sidePanel: redesignedLightSidePanelSemanticStyles,
  searchBar: redesignedLightSearchBarSemanticStyles,

  verticalSwitcher: redesignedLightVerticalSwitcherSemanticStyles,
  message: redesignedLightMessageSemanticStyles,

  icon: {
    info: colorPrimitive.blurple['600'],
  },
} satisfies DeepPartial<UserTheme>);
